<yes-no
  [title]="'Offerte nodig'"
  [showExtraInstructionsOn]="null"
  [value]="inputProduct.needsInvoice"
  [disabled]="isCustomWindowSticker()"
  [nullable]="true"
  (answer)="needsInvoiceChange($event)"
></yes-no>

<div *ngIf="inputProduct.needsInvoice && isWindowSticker()">
  <div class="title">Standaardprijzen</div>

  <p *ngIf="inputProduct.productSize == null">
    Nog geen materiaal geselecteerd
  </p>
  <div *ngIf="inputProduct.productSize != null" class="d-flex">
    <div class="first-form-field">
      <div class="price-label">Productieprijs</div>
      <mat-form-field appearance="outline">
        <input
          matInput
          [disabled]="true"
          [value]="'€ ' + displayProductionPrice(inputProduct.productSize)"
        />
      </mat-form-field>
    </div>

    <div class="form-field-no-flex">
      <div class="price-label">Plaatsingsprijs</div>
      <mat-form-field appearance="outline">
        <input
          matInput
          [disabled]="true"
          [value]="'€ ' + displayPlacementPrice(inputProduct.productSize)"
        />
      </mat-form-field>
    </div>

    <div>
      <div class="price-label">Som</div>
      <mat-form-field appearance="outline">
        <input
          matInput
          [disabled]="true"
          [value]="'€ ' + displaySum(inputProduct.productSize)"
        />
      </mat-form-field>
    </div>
  </div>
</div>

<div *ngIf="isCustomWindowSticker()">
  <div class="title">Prijzen invullen</div>

  <div *ngIf="inputCustomSticker != null" class="d-flex">
    <div class="first-form-field">
      <div class="price-label">Productieprijs</div>
      <mat-form-field appearance="outline">
        <input
          matInput
          type="number"
          [(ngModel)]="inputCustomSticker.productionPrice"
          (input)="setProductionPriceCustom($event)"
        />
      </mat-form-field>
    </div>

    <div class="form-field-no-flex">
      <div class="price-label">Plaatsingsprijs</div>
      <mat-form-field appearance="outline">
        <input
          type="number"
          matInput
          [(ngModel)]="inputCustomSticker.placementPrice"
          (input)="setPlacementPriceCustom($event)"
        />
      </mat-form-field>
    </div>

    <div>
      <div class="price-label">Som</div>
      <mat-form-field appearance="outline">
        <input
          matInput
          [disabled]="true"
          [value]="'€ ' + displaySumCustom(inputCustomSticker)"
        />
      </mat-form-field>
    </div>
  </div>
  <div class="title">Extra prijzen</div>
  <price-line-picker
    [inputList]="inputCustomSticker.prices"
    (output)="pricesPicked($event)"
  >
  </price-line-picker>
</div>

<textarea-input
  *ngIf="inputProduct.needsInvoice"
  [title]="'Opmerkingen facturatie'"
  [placeholder]="'Noteer extra info voor de calculator hier'"
  [initContent]="inputProduct.extraInfoInvoice"
  (answer)="extraInfoInvoiceChange($event)"
></textarea-input>
